var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { StudyWithIncludesDto } from "./study-with-includes.dtos";
import { BaseStudySearchInput } from "./study.dtos";
import { USAStates } from "./usaStates";
import { ConsentDateSearchInput, ConsentType, IdentifiedPatientState } from "./consent.dtos";
export class StudyPatientConsentTotalsResult {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyPatientConsentTotalsResult.prototype, "all", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyPatientConsentTotalsResult.prototype, "pending", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyPatientConsentTotalsResult.prototype, "optedIn", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyPatientConsentTotalsResult.prototype, "optedOut", void 0);
export class StudyPatientConsentSearchInput {
}
__decorate([
    ValidateNested(),
    Type(() => BaseStudySearchInput),
    IsOptional(),
    __metadata("design:type", BaseStudySearchInput)
], StudyPatientConsentSearchInput.prototype, "study", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudyPatientConsentSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(ConsentType, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], StudyPatientConsentSearchInput.prototype, "consentType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], StudyPatientConsentSearchInput.prototype, "patientId", void 0);
__decorate([
    IsEnum(USAStates),
    IsOptional(),
    __metadata("design:type", String)
], StudyPatientConsentSearchInput.prototype, "patientState", void 0);
__decorate([
    ValidateNested(),
    Type(() => ConsentDateSearchInput),
    IsOptional(),
    __metadata("design:type", ConsentDateSearchInput)
], StudyPatientConsentSearchInput.prototype, "timestamp", void 0);
export class StudyPatientConsentSearchResult {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], StudyPatientConsentSearchResult.prototype, "total", void 0);
__decorate([
    Type(() => PatientConsentsByStudyDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], StudyPatientConsentSearchResult.prototype, "results", void 0);
export class PatientConsentsByStudyDto {
}
__decorate([
    Type(() => StudyWithIncludesDto),
    ValidateNested(),
    __metadata("design:type", StudyWithIncludesDto)
], PatientConsentsByStudyDto.prototype, "study", void 0);
__decorate([
    Type(() => PatientConsentDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], PatientConsentsByStudyDto.prototype, "consents", void 0);
export class PatientConsentDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientConsentDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], PatientConsentDto.prototype, "patientId", void 0);
__decorate([
    IsEnum(ConsentType),
    __metadata("design:type", String)
], PatientConsentDto.prototype, "consentType", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], PatientConsentDto.prototype, "timestamp", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], PatientConsentDto.prototype, "consentingByLink", void 0);
__decorate([
    IsEnum(IdentifiedPatientState),
    IsOptional(),
    __metadata("design:type", Object)
], PatientConsentDto.prototype, "state", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], PatientConsentDto.prototype, "pending", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], PatientConsentDto.prototype, "updateRecordsNeeded", void 0);
